import {FileUploadRes} from '@yasc/yasc-material-components';
import {CompanyMinimumRes} from '../cp';
import {ProjectContractStatus} from '../../../enums/project-contract';

export class ProjectContractMinRes {
    id = 0;
    contractNumber = '';
    name = '';
    customerId = 0;
    customer?: CompanyMinimumRes | null;
    projectId?: number | null;
    projectName = '';
    start!: string;
    end?: string | null;
    status: ProjectContractStatus = ProjectContractStatus.Draft;
    hasDocument = false;
    budgetCount = 0;
    isActive = true;
}

export class ProjectContractDetailRes extends ProjectContractMinRes {
    document?: FileUploadRes | null;
    comment = '';
    budgets: unknown[] = [];
}

export class ProjectContractCreateReq {
    contractNumber = '';
    name = '';
    customerId = 0;
    projectId?: number | null;
    start!: string;
    end?: string | null;
    status: ProjectContractStatus = ProjectContractStatus.Draft;
    documentId?: string | null;
    comment?: string | null;
}

export class ProjectContractUReq {
    contractNumber?: string | null;
    name?: string | null;
    customerId?: number | null;
    projectId?: number | null;
    clearProject?: boolean | null;
    start?: string | null;
    end?: string | null;
    clearEnd?: boolean | null;
    status?: ProjectContractStatus | null;
    documentId?: string | null;
    clearDocument?: boolean | null;
    comment?: string | null;
}

export class ProjectContractProjectReq {
    id?: number | null;
    contractNumber = '';
    name = '';
    start!: string;
    end?: string | null;
    status: ProjectContractStatus = ProjectContractStatus.Draft;
    documentId?: string | null;
    comment?: string | null;
}
